import { classNames } from '@shared/lib/classNames'
import { Button, Tooltip } from 'antd'
import './icon-switch.scss'

interface IconSwitchProps {
    children: JSX.Element
    text?: string
    value?: boolean
    onChange?: (value: boolean) => void
}

export const IconSwitch = ({ children, text, value, onChange }: IconSwitchProps) => {
    return (
        <Tooltip placement="topLeft" title={text}>
            <Button
                type="text"
                onClick={() => onChange?.(!value)}
                style={{ padding: '4px 5px' }}
                className={classNames('', {
                    'icon-off': !value
                })}
            >
                {children}
            </Button>
        </Tooltip>
    )
}
